import Vue from 'vue'
import routes from './routes'
import Router from 'vue-router'

//import middleware
import isAuthorized from './middleware/isAuthorized'

Vue.use(Router)



const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: routes
})


export default router
